import { Button } from 'uikit'
import { Field, Formik } from 'formik'
import { useBoolean } from 'react-use'
import { Form, Modal, TextAreaForm } from 'uikit'
import * as Yup from 'yup'
import { formFields } from './FinishedPaymentModal.constants'
import { useFinishPayment } from './services/useFinishPayment'

export const validationSchema = Yup.object().shape({
  [formFields.retryComment]: Yup.string()
    .matches(/\S/, 'Только пробелы не допустимы')
    .min(3, 'Минимум 3 символа')
    .required('Комментарий обязательное поле'),
})

export const FinishedPaymentModal = ({ id }) => {
  const { mutate: finishPayment, isLoading } = useFinishPayment(id)
  const [isOpen, setOpenModal] = useBoolean(false)

  const handleSubmit = async (values) => {
    finishPayment(values)
    setOpenModal(false)
  }

  return (
    <>
      <Button
        width="100%"
        onClick={() => setOpenModal(true)}
        colorPalette="orange"
        loading={isLoading}
      >
        Завершить
      </Button>
      <Modal isOpen={isOpen} onClose={() => setOpenModal(false)} title="Завершить платеж">
        <Formik
          initialValues={{}}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {(formProps) => {
            return (
              <Form
                footer={
                  <Button
                    colorPalette="orange"
                    loading={isLoading}
                    onClick={() => formProps.handleSubmit()}
                  >
                    Завершить
                  </Button>
                }
              >
                <Field
                  component={TextAreaForm}
                  name={formFields.retryComment}
                  placeholder="Укажите кем и когда иницируется завершение платежа"
                />
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
